export default __webpack_public_path__ + "437fd7055472d7d7f3edd2ff2e09f2f9.png";